









import { Component, Vue } from 'vue-property-decorator'
import OrdersLegacy from '@/views/Company/Settings/Orders/OrdersLegacy.vue'
import OrdersPipelinesEnabled from '@/views/Company/Settings/Orders/OrdersPipelinesEnabled.vue'
import ModuleIframe from '@/components/ui/ModuleIframe.vue'

@Component({
    components: {
        ModuleIframe,
        OrdersLegacy,
        OrdersPipelinesEnabled,
    },
})
export default class Orders extends Vue {}
